import { GetUserProductEntitlementsModelDto as BoCompanyUserProductEntitlementsDto } from '@treasury/api/bo';
import { GetUserProductEntitlementsModelDto as ConsumerCompanyUserProductEntitlementsDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { Claim } from './claim.entity';
import { CompanyUserProductAccount } from './company-user-product-account.entity';
import { UserClaim } from './user-claim.entity';

const defaultCompanyUserProductEntitlements: BoCompanyUserProductEntitlementsDto = {
    productType: '',
    userProductClaims: [],
    accountProductClaims: [],
    accounts: [],
};

export class CompanyUserProductEntitlements extends DomainEntity<
    BoCompanyUserProductEntitlementsDto | ConsumerCompanyUserProductEntitlementsDto
> {
    constructor(data: BoCompanyUserProductEntitlementsDto) {
        super(data);
        this.userProductClaims = data.userProductClaims?.map(claim => new UserClaim(claim)) ?? [];
        this.accountProductClaims = data.accountProductClaims?.map(claim => new Claim(claim)) ?? [];
        this.accounts = data.accounts?.map(account => new CompanyUserProductAccount(account)) ?? [];
    }

    public get productType() {
        return this.dto.productType;
    }

    public userProductClaims: UserClaim[] = [];

    public accountProductClaims: Claim[] = [];

    public accounts: CompanyUserProductAccount[] = [];

    public getAccountClaimsByClaimId(claimId: number) {
        return (this.accounts ?? [])
            .map(account => {
                return (account.userAccountClaims ?? []).filter(
                    userAccountClaim => userAccountClaim.id === claimId
                );
            })
            .flat();
    }

    public createDefault(): this {
        return new CompanyUserProductEntitlements(defaultCompanyUserProductEntitlements) as this;
    }
}
